import React, { Component } from "react";
import FilterActiveIcon from "../../../icons/filteractiveicon";
import FilterIcon from "../../../icons/filtericon";
import RightArrow from "../../../assets/images/cms_right_arrow.svg"
//moment import
import moment from "moment-timezone";

//Loader import
import Loader from "../../loader";

//Redux Connect
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { ActCreators } from "../../../redux/bindActionCretor";
import { WAITLIST_THRESHOLD } from "../../../cosntants";
import EditIcon from "../../../icons/EditIcon";

const mapStateToProps = (state) => ({});

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators(ActCreators, dispatch);
};


class WaitlistListComp extends Component {
  constructor(props) {
    super(props);

    this.state = {
      loaderFlag: false,
      data: [
        {
          label: "product list",
          Content: "This is content for Tab 1",
        },
      ],
    };
    this.statusCache = {};
  }

  // handle view more button
  handleViewMore = (e,data) => {
    this.props.history.push(`/waitlist-management/${data.eventiveId}`);
  }

  componentDidUpdate(prevProps) {
    if (prevProps.emailTemplateListDocs !== this.props.emailTemplateListDocs) {
      const currentIds = new Set(
        (this.props.emailTemplateListDocs || []).map(item => item.eventiveId).filter(Boolean)
      );
      Object.keys(this.statusCache).forEach(key => {
        if (!currentIds.has(key)) {
          delete this.statusCache[key];
        }
      });
    }
  }

  getStatus = (date) => {
    const { FULL_PCT, REOPEN_PCT } = WAITLIST_THRESHOLD;
    const occupied = date.reservedSlots || 0;
    const capacity = date.maxWaitListSlots || 0;

    const pct = capacity > 0 ? Math.round((occupied / capacity) * 100) : 0;

    const canCache = Boolean(date.eventiveId);

    const prevStatus = canCache ? this.statusCache[date.eventiveId] : undefined;
    let isFull;
    if (pct >= FULL_PCT) {
      isFull = true;
    } else if (pct <= REOPEN_PCT) {
      isFull = false;
    } else {
      isFull = prevStatus === 'full';
    }

    let status;
    if (isFull) {
      status = 'full';
    } else {
      const startDate = moment(
        new Date(new Date(date.dateTime).getTime() - Number(process.env.REACT_APP_WAITLIST_SCAN_BUTTON_DURATION) * 60000),
        "DD/MM/YYYY hh:mm:ss"
      );
      const startDate30min = moment(
        new Date(new Date(date.dateTime).getTime() - 30 * 60000),
        "DD/MM/YYYY hh:mm:ss"
      );
      const endDate = moment(new Date(date.dateTime), "DD/MM/YYYY hh:mm:ss");
      const testDate = moment(new Date(), "DD/MM/YYYY hh:mm:ss");

      if (testDate.isBetween(startDate30min, endDate)) {
        status = 'closed';
      } else if (testDate.isBetween(startDate, endDate) && capacity > 0) {
        status = 'open';
      } else {
        status = 'pending';
      }
    }

    if (canCache) {
      this.statusCache[date.eventiveId] = status;
    }
    return status;
  }

  render() {
    const { emailTemplateListDocs,loaderFlag } = this.props;
    return (
      <>
        {emailTemplateListDocs &&
        emailTemplateListDocs.length > 0 ?
          emailTemplateListDocs.sort((a,b) => new Date(a.dateTime) - new Date(b.dateTime)).map((item, i) => {
            const itemStatus = this.getStatus(item);
            return (
              <>
              <div className="sd_Waitlist_items ">
                <li className={itemStatus} onClick={(e) => this.handleViewMore(e,item)}>
                  <div className="sd_waitlist_desc disp_flex d_flex_just_between d_flex_align_center">
                    <div className="sd_wtlist_left">
                      <h5 className="common_waitlist_bold_text">{item?.article ? item.article +' '+ item.title : item.title ? item.title : item.name}</h5>
                      <p className="common_waitlist_normal_text">{item.location[0]?.name} - {item.location[0]?.city?.name} - {moment.tz(item.dateTime, "US/Mountain").format("h:mm A")} {moment.tz("America/Denver").format("z")}</p>
                      {item.maxWaitListSlots === 0 && <p className="sd_zero_waitlist_slots">0 Waitlist slots</p>}
                    </div>
                    <div className="sd_wtlist_center">
                      <p><span className="common_waitlist_normal_text">Queue Status: </span><span className="common_waitlist_bold_text capitalize">{itemStatus}</span></p>
                      <p><span className="common_waitlist_normal_text">Reserved: </span><span className="common_waitlist_bold_text">{item.maxWaitListSlots > 0 ? Math.round(((item.reservedSlots || 0)/item.maxWaitListSlots)*100).toFixed(0) : 0}%</span></p>
                    </div>
                    <div className="sd_wtlist_right">
                      <button className="capitalize disp_flex d_flex_align_center view_more" onClick={(e) => this.handleViewMore(e,item)}>View<img src={RightArrow} alt="RightArrow"/></button>
                    </div>
                  </div>
                  <div className="mobile_view_btn">
                    <button className="capitalize disp_flex d_flex_align_center view_more" onClick={(e) => this.handleViewMore(e,item)}><img src={RightArrow} alt="RightArrow"/></button>
                  </div>
                </li>
              </div>
            </>
            );
          }) : <p className="sd_waitlist_notfound">There are no screenings scheduled within the next 3 hours.</p>
      }

        {/* Loader */}
        {loaderFlag ? <Loader /> : ""}
      </>
    );
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(WaitlistListComp);
